import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-handle-self-order',
  templateUrl: './handle-self-order.component.html',
  styleUrls: ['./handle-self-order.component.scss'],
})
export class HandleSelfOrderComponent implements OnInit {
  showTableInput = false;
  source: string;

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {}

  selectOrderType(orderType: string) {
    this.activeModal.close(orderType);
  }

  showTableForm() {
    this.showTableInput = true;
  }

  collectTableNumber(e: string) {
    if (e && e !== 'closed modal') {
      this.activeModal.close(e);
    }
  }
}
